<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('jobPost.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_job_post')"
                :title="$addLabel('Job Post')"
                @click="openJobPostModal()"
            />
        </app-page-top-section>

        <app-table
            id="job-post-table"
            :options="options"
            @action="triggerActions"
        />

        <app-job-post-modal
            v-if="isJobPostModalActive"
            v-model="isJobPostModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('job-post-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import JobPostMixin from "../../../Mixins/Recruitment/JobPost";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {JOB_POST_FORM, JOB_POST_WEB} from "../../../../Config/ApiUrl";

export default {
    name: "Job-Post",
    mixins: [JobPostMixin],
    data() {
        return {
            jobPost: '',
            jobPostId: '',
            jobPosts: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            isJobPostModalActive: false,
            confirmationModalActive: false,
        }
    },
    watch: {
        isJobPostModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openJobPostModal() {
            this.selectedUrl = '';
            this.isJobPostModalActive = true;
        },
        triggerActions(row, action, active) {
            this.jobId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isJobPostModalActive = true;
            }
            if (action.name === 'view_details') {
                this.selectedUrl = window.location = urlGenerator(`${JOB_POST_WEB}/${row.id}`);
            }
            if (action.name === 'copy_link') {
                const linkUrl = `${urlGenerator(JOB_POST_FORM)}?requitementId=${row.id}`;
                this.copyToClipboard(linkUrl)

            } else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
        async copyToClipboard(url) {
            if (navigator.clipboard) {
                // Modern browsers: Use Clipboard API
                try {
                    await navigator.clipboard.writeText(url);
                    this.toastAndReload('URL copied to clipboard!');
                } catch (error) {
                    console.error('Failed to copy URL:', error);
                    this.toastAndReload('Failed to copy URL!');
                }
            } else {
                // Fallback for older browsers
                const el = document.createElement('textarea');
                el.value = url;
                document.body.appendChild(el);
                el.select();
                try {
                    document.execCommand('copy');
                    this.toastAndReload('URL copied to clipboard!');
                } catch (error) {
                    console.error('Failed to copy URL:', error);
                    this.toastAndReload('Failed to copy URL!');
                } finally {
                    document.body.removeChild(el);
                }
            }
        }
    }
}
</script>
